<template>
  <button :type="nativeType" @click="handleClick" class="my-button-box">
    <slot></slot>
  </button>
</template>
<script>
// <Button4></Button4>

export default {
  name: 'Button4',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>

//
.my-button-box{
  height: 40px;
  line-height: 40px;
  border: none;
  background:#409ee9;
  background:rgba(2,134,223,0.1);
  border: 1px solid #0286df;
  padding: 0 21px;
  border-radius: 4px;
  color: #0286df;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  &:hover{
    // border: 1px solid #409ee9;
  }
}
</style>
